import { render, staticRenderFns } from "./DataFormInput.vue?vue&type=template&id=0d0f9b3b"
import script from "./DataFormInput.vue?vue&type=script&lang=js"
export * from "./DataFormInput.vue?vue&type=script&lang=js"
import style0 from "./DataFormInput.vue?vue&type=style&index=0&id=0d0f9b3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports